/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

export { OrderItemAttributeDrawer as OrderItemTableV2AttributeDrawer } from '@/components/content/OrderItemTable/parts/AttributeDrawer';
